<template>
  <section style="background:url(/images/bg2.jpg); background-attachment: fixed;">
    <!-- <div style="background-color:rgba(243,127,0,0.9); padding: 100px 0;"> -->
    <div style="background-color:rgba(32,150,243,0.85); padding: 100px 0;">
      <v-container grid-list-lg>
        <v-layout justify-space-between row wrap>
          <v-flex md6 lg4>
            <v-layout row wrap>
              <VueGallery
                :images="$store.getters.bigImages(6)"
                :index="index"
                @close="index = null"
              ></VueGallery>
              <v-flex
                v-for="(image, i) in $store.getters.smallImages(6)"
                :key="i+`sm`"
                xs4
                sm2
                md6
                lg6
                xl4
                d-flex
              >
                <v-hover>
                  <v-card
                    flat
                    tile
                    class="d-flex"
                    slot-scope="{ hover }"
                    @click="index = i"
                    :class="`elevation-${hover ? 12 : 2}`"
                  >
                    <v-img :src="image" aspect-ratio="1" class="grey lighten-2">
                      <template v-slot:placeholder>
                        <v-layout fill-height align-center justify-center ma-0>
                          <v-progress-circular indeterminate color="blue lighten-5"></v-progress-circular>
                        </v-layout>
                      </template>
                    </v-img>
                  </v-card>
                </v-hover>
              </v-flex>
            </v-layout>
            <p style="text-align:center;">
              <small>
                <a
                  href="/institucional/espaco-fisico"
                  style="color:white; text-decoration:none;"
                >ver mais fotos</a>
              </small>
            </p>
          </v-flex>
          <v-flex md6 lg7>
            <h2>A primeira escola particular do sul da ilha</h2>
            <p
              class="lead"
            >A Escola Engenho desenvolve uma proposta de ensino, em que o conhecimento é associado ao conjunto da formação individual. Isso implica em privilegiar o processo de aprendizagem mediante atividades em grupo, valorizando a realidade sociocultural de cada aluno.</p>
            <p>Com isto, a diversidade não é apenas admitida, mas sobretudo trabalhada, para mediar as tensões que emergem no interior de toda e qualquer situação relacional.</p>
            <p>Por esta via, os alunos são preparados para negociar no dia-a-dia as alternativas disponíveis e os seus sonhos quanto ao amanhã.</p>
            <p>Acreditando que estas orientações são decisivas para a formação dos nossos alunos, convidamos você a conhecer um pouco do nosso trabalho.</p>
            <br>
            <p>
              <v-btn
                color="white"
                class="ml-0"
                depressed
                round
                href="/institucional/historia"
              >Nossa História</v-btn>
              <v-btn
                color="white"
                class="ml-0"
                depressed
                round
                href="/institucional/espaco-fisico"
              >Espaço Físico</v-btn>
              <v-btn
                color="white"
                class="ml-0"
                depressed
                round
                href="/pedagogico/proposta"
              >Proposta Pedagógica</v-btn>
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </section>
</template>

<script>
import VueGallery from "vue-gallery";
export default {
  components: {
    VueGallery
  },
  data: () => ({
    index: null,
    items: [
      {
        title1: "Matrículas",
        title2: "2019",
        icon: "forward",
        link: "#",
        color: "blue"
      },
      {
        title1: "Espaço",
        title2: "Físico",
        icon: "business",
        link: "/institucional/espaco-fisico",
        color: "orange"
      },
      {
        title1: "Calendário",
        title2: "Escolar",
        icon: "event",
        link: "/institucional/calendario",
        color: "blue"
      },
      {
        title1: "Lista de",
        title2: "Material",
        icon: "list_alt",
        link: "/institucional/lista-de-materiais",
        color: "orange"
      }
    ]
  })
};
</script>

<style lang="scss" scoped>
h2,
p {
  text-align: left;
  color: white;
}

.v-card {
  cursor: pointer;
}

// XS
@media screen and (max-width: 600px) {
}

// SM
@media screen and (max-width: 960px) and (min-width: 601px) {
}

// MD
@media screen and (max-width: 1264px) and (min-width: 961px) {
}

// LG
@media screen and (max-width: 1904px) and (min-width: 1265px) {
}

// XL
@media screen and (min-width: 1905px) {
}
</style>
